// extracted by mini-css-extract-plugin
export default {"MainLayout":"mainLayout_MainLayout__YNITA","wrapper":"mainLayout_wrapper__l6DRG"};